var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.quoteHtml)?_c('div',{staticClass:"Component quote-news"},[_c('blockquote',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.quoteHtml)}}),(_vm.author)?_c('p',{staticClass:"author"},[_vm._v(_vm._s(_vm.author))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }